<template>
  <b-modal
    title="Ресурсы курса"
    ref="modal"
    :id="modalId"
    header-bg-variant="primary"
    header-text-variant="light"
    ok-title="ОК"
    ok-variant="primary"
    ok-only
    size="xl"
  >
    <b-button @click="onUpload" class="mb-1" variant="outline-primary" v-if="allowAdd">
      Загрузить
    </b-button>
    <b-button @click="onUploadTileSet" class="ml-2 mb-1" variant="outline-primary" v-if="allowAdd">
      Загрузить TileSet
    </b-button>
    <b-form-file
      @change="loadFiles($event.target)"
      multiple
      plain
      hidden
      id="tilesetFileInput"
      accept=".json, image/jpeg, image/png"
      ref="tileset-file-input"
    ></b-form-file>
    <ag-grid-vue
      style="width: 100%; height: 400px;"
      class="ag-theme-material"
      :columnDefs="columnDefs"
      :rowData="rowData"
      :gridOptions="gridOptions"
      :frameworkComponents="frameworkComponents"
      :context="context"
      @gridReady="gridReady"
    >
    </ag-grid-vue>
    <v-modal-files-upload
      modalId="resource-upload-modal"
      wrkspcType="resources"
      :fileHandler="onResourceUploaded"
    >
    </v-modal-files-upload>
    <TilesetModal @fileReady="onAddTileset" />
  </b-modal>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import { mapGetters, mapActions } from 'vuex'

import ResourceActionRenderer from '@/components/helpers/renderers/training/ActionRenderer'
import PreviewRenderer from '@/components/helpers/renderers/training/PreviewRenderer'
import TypeRenderer from '@/components/helpers/renderers/training/TypeRenderer'
import IdRenderer from '@/components/helpers/renderers/training/IdRenderer'
import VModalFilesUpload from '@/components/content/edit/modals/ModalFilesUpload.vue'
import TilesetModal from '@/components/content/education/training/modals/TilesetModal.vue'
import AG_GRID_LOCALE_RU from '@/config/locale.ru'

export default {
  name: 'ResourceModal',
  components: {
    AgGridVue,
    VModalFilesUpload,
    TilesetModal
  },
  data() {
    return {
      previewExtended: 0,
      columnDefs: [
        {
          headerName: 'id',
          headerClass: 'ag-grid-table-header',
          field: 'id',
          colId: 'id',
          sortable: true,
          filter: true,
          width: 110,
          suppressSizeToFit: true,
          cellRenderer: 'IdRenderer'
        },
        {
          headerName: 'Название',
          headerClass: 'ag-grid-table-header',
          field: 'file.name',
          colId: 'file.name',
          sortable: true,
          width: 516,
          suppressSizeToFit: true,
          filter: true
        },
        {
          headerName: 'Тип',
          headerClass: 'ag-grid-table-header',
          field: 'type',
          colId: 'type',
          sortable: true,
          filter: true,
          width: 120,
          suppressSizeToFit: true,
          cellRenderer: 'TypeRenderer'
        },
        {
          headerName: 'Просмотр',
          headerClass: 'ag-grid-table-header',
          field: 'preview',
          colId: 'preview',
          width: 280,
          suppressSizeToFit: true,
          cellRenderer: 'PreviewRenderer'
        },
        {
          headerName: '',
          headerClass: 'ag-grid-table-header',
          field: 'delete',
          colId: 'delete',
          suppressSizeToFit: true,
          width: 80,
          cellRenderer: 'ResourceActionRenderer'
        }
      ],
      gridOptions: {
        localeText: AG_GRID_LOCALE_RU,
        headerHeight: 40,
        getRowHeight() {
          return 50
        }
      },
      gridApi: null,
      columnApi: null,
      context: {
        componentParent: this
      },
      frameworkComponents: {
        ResourceActionRenderer,
        PreviewRenderer,
        TypeRenderer,
        IdRenderer
      }
    }
  },
  props: {
    modalId: {
      type: String,
      default() {
        return 'resourceModal'
      }
    },
    allowAdd: {
      type: Boolean,
      default() {
        return true
      }
    },
    select: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  computed: {
    ...mapGetters({
      resourceCollection: 'training/getResources',
      isInitialized: 'training/getIsTrainingInitialized'
    }),
    resources() {
      return this.resourceCollection.resources
    },
    rowData() {
      if (this.isInitialized) {
        return this.resources
      }
      return null
    }
  },
  methods: {
    ...mapActions({
      pushToasts: 'toasts/pushToasts',
      uploadFiles: 'workspace/uploadFiles',
      addNewFileToResources: 'training/addNewFileToResources',
      updateUpdater: 'contentManager/updateUpdater'
    }),
    onDelete() {
      this.updateUpdater()
    },
    gridReady(params) {
      params.api.sizeColumnsToFit()
      params.api.onRowHeightChanged()
      this.gridApi = params.api
      this.columnsApi = params.columnApi
    },
    toggleWidth(d) {
      this.previewExtended += d
      if (this.previewExtended > 0) {
        this.columnsApi.setColumnWidth('preview', 500)
      } else {
        this.columnsApi.setColumnWidth('preview', 250)
      }
      this.gridApi.sizeColumnsToFit()
      this.gridApi.onRowHeightChanged()
    },
    onSelect(e) {
      this.$emit('resourceSelected', e)
      this.$refs.modal.hide()
    },
    onUpload() {
      this.$bvModal.show('resource-upload-modal')
    },
    onUploadTileSet() {
      this.$bvModal.show('tilesetModal')
    },
    onResourceUploaded(files) {
      this.resourceCollection.addResources(files)
      this.updateUpdater()
      this.$bvModal.hide('resource-upload-modal')
    },
    onAddTileset({ file, json }) {
      this.resourceCollection.addTileset(file, json)
      this.updateUpdater()
    }
  }
}
</script>

<style scoped></style>
